import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownLeft1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.2 15.086 9.514 20.4m0 0 5.314-5.314M9.514 20.4V7.6a4 4 0 0 1 4-4H19.8"
    />
  </svg>
);
export default SvgArrowDownLeft1;
